export default __webpack_public_path__ + "static/media/technologyWebSite.87e9dbe3.jpg";